import { render, staticRenderFns } from "./ReviewRecords.vue?vue&type=template&id=1dc5ebf3&scoped=true"
import script from "./ReviewRecords.vue?vue&type=script&lang=js"
export * from "./ReviewRecords.vue?vue&type=script&lang=js"
import style0 from "./ReviewRecords.vue?vue&type=style&index=0&id=1dc5ebf3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc5ebf3",
  null
  
)

export default component.exports